import React from 'react';
export function About() {
  return <section className="bg-cream" data-id="element-19" data-mp="flifmlndueog">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-20" data-mp="fma9ns1c04cm">
        <div className="grid items-center gap-12 lg:grid-cols-[0.82fr_1.18fr] lg:gap-20" data-id="element-21" data-mp="2prqncnvoyegb">
          <div className="relative mx-auto w-full max-w-[340px] lg:max-w-none" data-id="element-22" data-mp="2triqum689uet">
            <div className="pointer-events-none absolute -left-4 -top-4 hidden h-full w-full rounded-[22px] border border-clay/30 lg:block" aria-hidden="true" data-id="element-23" data-mp="2yt8488gxak62" />
            <img src="https://cdn.magicpatterns.com/uploads/6M8xkKvDKDdXxr4BWXGodb/CAROLINA_MENDEZ.png" alt="Retrato de Carolina Méndez, arquitecta especializada en Feng Shui" className="relative w-full rounded-[22px] object-cover shadow-lift" loading="lazy" data-id="element-24" data-mp="38q2z8hdzm2fl" />
          </div>

          <div data-id="element-25" data-mp="3hkr62bz7ns6i">
            <p className="eyebrow flex items-center gap-2.5 text-[10px] text-clay sm:text-[11px]" data-id="element-26" data-mp="3mhrcinzz2wy5">
              <span className="h-px w-6 bg-clay/50" aria-hidden="true" data-id="element-27" data-mp="3rgu71eibtkrv" />
              Detrás de la guía
            </p>

            <h2 className="mt-4 text-[32px] font-semibold leading-[1.08] tracking-[-0.015em] text-ink sm:text-[44px] lg:text-[50px]" data-id="element-28" data-mp="2lrh8vv72wf96">
              Hola, soy <span className="text-clay" data-id="element-29" data-mp="2gqt84ht1sk1r">Carolina Méndez</span>
            </h2>

            <p className="mt-3 font-sans text-[14px] font-medium uppercase tracking-[0.12em] text-sage-deep sm:text-[15px]" data-id="element-30" data-mp="2crc3trpcxsy6">
              Arquitecta especializada en Feng Shui y diseño consciente
            </p>

            <p className="mt-7 text-[15.5px] leading-[1.85] text-ink-soft sm:text-[17px]" data-id="element-31" data-mp="34gxa6kql8bqn">
              Durante años aprendí que un hogar no solo debe verse bien: también tiene que sentirse
              bien y acompañar la forma en que vivimos.
            </p>
            <p className="mt-4 text-[15.5px] leading-[1.85] text-ink-soft sm:text-[17px]" data-id="element-32" data-mp="2qr3ky1b67pge">
              Por eso creé Armonía Interior, una guía práctica para acercarte al Feng Shui de manera
              simple, aplicable y sin complicaciones, para que puedas entender mejor tus espacios y
              transformarlos con mayor intención.
            </p>

            <blockquote className="mt-9 border-l-2 border-clay pl-6" data-id="element-33" data-mp="686h2ywmmwvm">
              <p className="font-display text-[19px] italic leading-[1.5] text-ink sm:text-[24px]" data-id="element-34" data-mp="b4exsgqh2y4w">
                “Tu hogar no necesita ser perfecto. Necesita acompañar la vida que querés vivir.”
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}